import { ApiPage, ApiBQTable } from "./api_data";
import { div } from "../../shared/dom";
import { Display } from "./display";
import { BQ } from "./bq";
import { App } from "./app";
import { Loading } from "../../shared/loading";

export interface VizConnection {
  id: string;
  viz: Display;
  position: number;
  group: string;
}

export class Page {

  static page: Page | null = null;

  viz_list: VizConnection[] = [];

  id: string;
  owner_id: string;
  title: string;
  version: number;

  selected_element: string | null = null;
  data_panel_open = false;
  show_query: boolean = false;

  constructor(id: string, owner_id: string, title: string, version: number) {
    this.id = id;
    this.owner_id = owner_id;
    this.title = title;
    this.version = version;
  }

  static parse(api_page: ApiPage, tables: ApiBQTable[]): Page {
    const page = new Page(api_page.id, api_page.owner_id, api_page.title, api_page.version);
    for (const api_d of api_page.displays) {
      const d = Display.parse(api_d, tables);
      if (api_page.connections) {
        for (const conn of api_page.connections) {
          if (conn.key !== "viz" || conn.child !== d.id) {
            continue;
          }
          let group = "left";
          let position = 0;
          if (api_page.attributes) {
            for (const attr of api_page.attributes) {
              if (attr.parent !== conn.id) {
                continue;
              }
              if (attr.key === "group") {
                if (attr.text === "right") {
                  group = "right";
                }
              } else if (attr.key === "position") {
                if (attr.number) {
                  position = attr.number;
                }
              }
            }
          }
          const c: VizConnection = {
            id: conn.id,
            viz: d,
            position: position,
            group: group,
          }
          page.viz_list.push(c);
        }
      }
    }
    if (App.user && api_page.attributes) {
      for (const attr of api_page.attributes) {
        if (attr.parent !== App.user.id) {
          continue;
        }
        if (attr.key === "selected_element" && attr.text) {
          page.selected_element = attr.text;
        } else if (attr.key === "data_panel_open") {
          const b = attr.number === 1 ? true : false;
          page.data_panel_open = b;
        }
      }
    }

    page.viz_list.sort(function (a, b) {
      return a.position - b.position;
    });
    return page;
  }

  static render_viz(conn: VizConnection): HTMLElement {
    const d = div("display", "loading");

    const content = div("content");
    d.appendChild(content);

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("display_00c0f3");
    content.appendChild(svg);

    content.appendChild(Loading.overlay());
    Display.render(conn.viz, svg, 11);

    if (conn.viz.selected_table) {
      BQ.run(conn.viz.selected_table.table, conn.viz, function () {
        d.classList.remove("loading");
        Display.render(conn.viz, svg, 11);
      }, function () {
        // error
        d.classList.remove("loading");
      })
    } else {
      d.classList.remove("loading");
    }
    return d;
  }

  static render_nav(container: HTMLElement) {
    container.innerHTML = "";
    if (!Page.page) {
      return;
    }
    const h1 = document.createElement("h1");
    h1.innerText = Page.page.title;
    container.appendChild(h1);
  }

  static render_main(container: HTMLElement) {
    container.innerHTML = "";

    if (!Page.page) {
      return;
    }
    const page = Page.page;

    const wrap = div("wrapper");
    container.appendChild(wrap);
    const cols = div("flex-col-container");
    wrap.appendChild(cols);

    const render_col = function (viz_list: VizConnection[], group_key: string) {
      const col = div("col");
      cols.appendChild(col);

      const set = div();
      col.appendChild(set);
      for (const v of viz_list) {
        if (v.group !== group_key) {
          continue;
        }
        const viz_el = Page.render_viz(v);
        set.appendChild(viz_el);
      }
    }

    render_col(page.viz_list, "left");
    cols.appendChild(div("col-spacer"));
    render_col(page.viz_list, "right");
  }

}